<template>
  <v-dialog max-width="750" :value="dialog" @click:outside="close">
    <v-card class="align-center d-flex flex-column py-10 px-7">
      <CloseDialogButton :close="close" />
      <SupportContent />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import SupportContent from "@/components/Support/Content.vue";

export default {
  name: "SupportDialog",
  components: { CloseDialogButton, SupportContent },
  props: {
    close: Function,
    dialog: Boolean,
  },
};
</script>
